module.exports = __webpack_public_path__ + "static/img/homepage_cover.1149227.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage_cover.png
// module id = 32
// module chunks = 1